// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-hFjMrl","editBtn":"editBtn-pWooE2","text":"text-HapmLa"};